import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ApiSettings } from '@hub/generated/apiSettings';
import { CurrentUserService } from '@hub/services/index';
import { MenuService } from './menu/service/menu.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'header',
  templateUrl: 'header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnDestroy {
  private readonly subscriptions = new Subscription();

  constructor(
    private router: Router,
    private menuService: MenuService,
    private currentUser: CurrentUserService
  ) {
    this.setHeaderColor();
    this.subscriptions.add(this.currentUser.FullName.subscribe(text => this.FullName = text));
    this.subscriptions.add(this.currentUser.UserAvatar.subscribe(text => this.UserAvatar = text));
  }

  public FullName: string;
  public UserAvatar: string;
  public HeaderColor: string;

  toggleMenu() {
    this.menuService.toggle(true);
  }

  logout() {
    this.router.navigate(['logout']);
  }

  myProfile(){
    this.router.navigate(['users/detail/'+this.currentUser.Id.getValue()]);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private setHeaderColor(): void {
    switch (ApiSettings.Environment) {
      case 'Development':
        this.HeaderColor = '#e43243';
        break;
      case 'Staging':
        this.HeaderColor = '#40de86';
        break;
      case 'QA':
        this.HeaderColor = '#000c06';
        break;
      default:
        this.HeaderColor = '#0060AA';
        break;
    }
  }
}
